import React from 'react'
import PropTypes from 'prop-types'
import FinancialAccountRow from './FinancialAccountRow'
import FinancialAccountHeader from './FinancialAccountHeader'
import classnames from 'classnames'
import styles from './FinancialAccountsList.module.scss'

const FinancialAccountsList = (props) => {
  const {
    financialAccounts,
    title,
    showMarketValue,
    accountNameLabel,
    isAccountNumberMasked,
    className
  } = props

  const styleClasses = classnames(styles.FinancialAccountsList, className)

  return (
    <div className={styleClasses} data-test-id="financialAccountSummaryId">
      <p className={styles.title}>{title}</p>
      <FinancialAccountHeader
        testId="financialAccountHeader-testId"
        showMarketValue={showMarketValue}
        accountNameLabel={accountNameLabel} />
      {
        financialAccounts.map((financialAccount, i) => (
          <FinancialAccountRow
            key={i}
            name={financialAccount.name}
            accountNumber={financialAccount.accountNumber}
            totalEmv={financialAccount.totalEmv}
            showMarketValue={showMarketValue}
            isAccountNumberMasked={isAccountNumberMasked} />
        ))
      }
    </div>
  )
}

FinancialAccountsList.defaultProps = {
  financialAccounts: [],
  title: 'Investments Summary',
  showMarketValue: true,
  accountNameLabel: 'Investments',
  isAccountNumberMasked: true,
  className: '',
}

FinancialAccountsList.propTypes = {
  className: PropTypes.string,
  financialAccounts: PropTypes.array,
  title: PropTypes.string,
  showMarketValue: PropTypes.bool,
  accountNameLabel: PropTypes.string,
  isAccountNumberMasked: PropTypes.bool
}

export default FinancialAccountsList



// WEBPACK FOOTER //
// ./src/components/Client/FinancialAccountsList/FinancialAccountsList.jsx